module.exports = __webpack_public_path__ + "static/media/caret-down.8d61062c.svg";